
import React from 'react';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import {  Link } from "react-router-dom";
import Box from '@mui/material/Box';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import InputAdornment from '@mui/material/InputAdornment';
import { InputBase } from '@mui/material';
import JotformEmbed from 'react-jotform-embed';

function Copyright() {
  return (
    <Typography variant="body2" style={{color: 'white', fontFamily: 'Poppins'}}>      
       <Link to='/privacypolicy' style={{textDecoration: 'none', color: 'white'}}>Privacy Policy |</Link>
       <Link to='/termsofuse' style={{textDecoration: 'none', color: 'white'}}> Terms of Use | </Link>
       <Box display={{ xs: 'block', sm: 'none' }}><br/></Box>
      {'Copyright ©     '}
      <Link to='/' color="inherit" 
      style={{textDecoration: 'none', color: 'white'}}>
         Diversified Products Company, LLC. 
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
function handleClick(e) {
  e.preventDefault();
  alert('Thankyou! Your email has been recieved');
}
const useStyles = makeStyles(theme => ({
    '@global': {
      ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
      },
    },
    footer: {   
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
      },
    },
    headerlink:{
      textDecoration: 'none',
      color: 'white',
      fontFamily: 'Poppins',
      fontSize: '25px',
  },
    link:
    {
      textDecoration: 'none',
      color: 'white',
      fontSize: '16px',
      fontFamily: 'Poppins'
    },
    textfield:{
      margin: '5px',
      backgroundColor: 'white',
      color: 'black',
      borderRadius: '20px',
      paddingLeft: '8px'
  },
    signup:{
      color: 'white', 
      border: '2px solid white', 
      padding: '4px',
      margin: '3px',
    }, 
  }));

export default function Footer() {
  const classes = useStyles(); 
  return (
    <div style={{backgroundColor: '#02192D', borderTop: '1px solid #e4e4e4'}}>      
    <Container maxWidth="lg" component="footer" className={classes.footer} >
        <Grid container spacing={2}>        
            <Grid item xs={6} sm={3} md={4} lg={4} >
              <Typography gutterBottom className={classes.headerlink}>
              LFT 360</Typography>
              <ul>    
              <Link to='/' className={classes.link}><li>Home  </li></Link>  
              <a href='/#contact' className={classes.link}><li>Contact  </li> </a>  
              <a href='/#about' className={classes.link}><li>About </li> </a>
              <a href='/#wheretobuy' className={classes.link}><li>Where to Buy </li>  </a>
              {/* <a href='/#products' className={classes.link}><li>Products </li>  </a>                */}
              </ul>
            </Grid>  
            <Grid item xs={6} sm={3} md={4} lg={4}>
              <Typography gutterBottom className={classes.headerlink}>                
              Quick Links
              </Typography>                 
              <ul>
              <Link to='/hoistrings' className={classes.link}><li>Hoist Rings</li></Link>  

              {/* <Link to='/technicalresources' className={classes.link}><li>Technical Resources </li></Link>     */}
              <Link to='/onlinecerts' className={classes.link}><li>Online Certs</li></Link>
              </ul>              
            </Grid>  
                             
            <Grid item xs={12} sm={6} md={4} lg={4}>
            <Typography className={classes.headerlink} style={{paddingLeft:'20px', paddingBottom: '5px'}}> N E W S L E T T E R</Typography>             
            <Typography className={classes.link} style={{paddingLeft:'20px'}}>Sign up for new LFT releases</Typography>                       
            <JotformEmbed src="https://form.jotform.com/233035706819155" />
        </Grid>
        </Grid>
        <Box mt={5}>
          <Copyright />
        </Box>
        <div style={{marginBottom: '30px'}}></div>
      </Container>
      </div>
  );
}
